/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
'use client';

import { FloatingLabelInput } from '@ahm/react-ui';
import { Stack, rem } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import type { RatingFormData } from './types';
import NoteIcon from '@/assets/icons/note-pencil-icon.svg';

export function CommentSection() {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext<RatingFormData>();
  const rating = watch('rating');
  const isPositiveRating = rating >= 4;

  return (
    <Stack gap={rem(16)} p={rem(16)} w="100%">
      <Controller
        name="comment"
        control={control}
        render={({ field }) => (
          <>
            <FloatingLabelInput
              {...field}
              name="comment"
              value={field.value || undefined}
              onChange={(value) => field.onChange(value)}
              label={isPositiveRating ? 'Để lại lời khen' : 'Góp ý cho Ahamove'}
              min={0}
              leftSection={<NoteIcon />}
              height={rem(56)}
              error={errors.comment?.message}
              styles={{
                root: { width: '100%' },
                input: { height: rem(56) },
              }}
            />
          </>
        )}
      />
    </Stack>
  );
}
